export default __webpack_public_path__ + "static/media/picking.c1dd80f2.svg";